module.exports = __webpack_public_path__ + "img/RedAltar.1d44a8cd.png";